var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"excelReportsView"},[_c('menu-layout',{attrs:{"title":"Excel Reports"},scopedSlots:_vm._u([{key:"body-content",fn:function(){return [_c('lookups-component'),_vm._v(" "),_c('report-generator-component',{staticClass:"mt-3"})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }